import React from 'react'
import PropTypes from 'prop-types'
import SVG from 'react-inlinesvg'
import classnames from 'classnames'

const themeProps = {
  icon: {
    default: 'yellow',
    danger: 'red'
  }
}

const Notice = ({ className, ...props }) => {
  const { theme } = props
  const icon = themeProps.icon[theme]

  return (
    <div className={classnames('notice', `notice--${theme}`, className)}>
      <div className="notice__container">
        { icon ? (
            <SVG src={require(`@icons/notice/${icon}.svg`)} />
          ) : null
        }
        <div className="notice__content f--md">{ props.children }</div>
      </div>
    </div>
  )
}

Notice.propTypes = {
  theme: PropTypes.string.isRequired
}

Notice.defaultProps = {
  theme: "default"
}

export default Notice
